export const SmtpAction = async ({ to }) => {
  const token = JSON.parse(localStorage.getItem("slotbook"));
 
  const accessToken = token?.accessToken;
  try {
    const formattedTo = `<${to}>`;
    let data = {
      receiver_email: to,
    };
    const response = await fetch(
      // `https://apipostman.onlinecu.in/exam_sch/api/password-reset/${formattedTo}/`,
      `https://apipostman.onlinecu.in/exam_sch/api/password-reset/${formattedTo}/`,
      {
        method: "put",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      }
    );
  
    if (response.ok === true || response.status === 200) {
      swal({
        title: `Email sent successfully!!`,
        text: "Email Sent",
        icon: "success",
        button: "Close",
      });
    } else {
      const errorData = await response.json();
     
      swal({
        title: `${errorData.message}`,
        text: error?.message,
        icon: "warning",
        button: "Close",
      });
    }
  } catch (error) {
    console.error("Error sending email:", error);
    swal({
      title: `${errorData.message}`,
      text: error?.message,
      icon: "warning",
      button: "Close",
    });
  }
};
